import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { CampaignFormSection, Frequency } from '../enums/schedulingConstant';

function useCampaignFormData(formSection = '') {
  const campaignName = useSelector(
    store => store.campaign.campaignFormState.campaignDetails?.campaignName,
  );
  const campaignDescription = useSelector(
    store => store.campaign.campaignFormState.campaignDetails?.campaignDescription,
  );
  const campaignType = useSelector(
    store => store.campaign.campaignFormState.campaignDetails?.campaignType,
  );
  const channelType = useSelector(
    store => store.campaign.campaignFormState.campaignDetails?.channelType,
  );
  const segmentName = useSelector(
    store => store.campaign.campaignFormState?.segmentDetails?.segmentName,
  );
  const segmentId = useSelector(
    store => store.campaign.campaignFormState?.segmentDetails?.segmentId,
  );
  const sendImmediate = useSelector(
    store => store.campaign.campaignFormState.campaignDetails?.sendImmediate,
  );
  const messageTemplateName = useSelector(
    store => store.campaign.campaignFormState?.templateDetails?.messageTemplateName,
  );

  const fromAddress = useSelector(
    store => store.campaign.campaignFormState?.templateDetails?.fromAddress,
  );
  const frequency = useSelector(
    store => store.campaign.campaignFormState?.campaignDetails?.frequency,
  );
  const startTime = useSelector(
    store => store.campaign.campaignFormState?.campaignDetails?.startTime,
  );
  const endTime = useSelector(store => store.campaign.campaignFormState?.campaignDetails?.endTime);
  const timeZone = useSelector(
    store => store.campaign.campaignFormState?.campaignDetails?.timeZone,
  );

  let result = {
    isFormSectionValid: false,
    formSectionName: '',
    formSectionData: {},
  };

  switch (formSection) {
    case CampaignFormSection.CAMPAIGN: {
      result = {
        isFormSectionValid:
          !isEmpty(campaignName) && !isEmpty(campaignType) && !isEmpty(channelType),
        formSectionName: formSection,
        formSectionData: {
          campaignName,
          campaignDescription,
          campaignType,
          channelType,
        },
      };
      break;
    }
    case CampaignFormSection.SEGMENT: {
      result = {
        isFormSectionValid: !isEmpty(segmentName) && !isEmpty(segmentId),
        formSectionName: formSection,
        formSectionData: {
          segmentName,
          segmentId,
        },
      };
      break;
    }
    case CampaignFormSection.TEMPLATE: {
      result = {
        isFormSectionValid: !isEmpty(messageTemplateName) && !isEmpty(fromAddress),
        formSectionName: formSection,
        formSectionData: {
          messageTemplateName,
        },
      };
      break;
    }
    case CampaignFormSection.SCHEDULE: {
      result = {
        isFormSectionValid: sendImmediate
          ? !isEmpty(frequency)
          : frequency === Frequency.ONCE
            ? !isEmpty(frequency) && !isEmpty(startTime) && !isEmpty(timeZone)
            : !isEmpty(frequency) && !isEmpty(startTime) && !isEmpty(endTime) && !isEmpty(timeZone),
        formSectionName: formSection,
        formSectionData: {
          frequency,
          startTime,
          endTime,
          timeZone,
        },
      };
      break;
    }
    case CampaignFormSection.REVIEW: {
      result = {
        isFormSectionValid: true,
        formSectionName: formSection,
        formSectionData: {
          campaignName,
          campaignDescription,
          campaignType,
          channelType,
          segmentId,
          segmentName,
          messageTemplateName,
          frequency,
        },
      };
      break;
    }
    default: {
      result = {
        isFormSectionValid: false,
        formSectionName: '',
        formSectionData: {},
      };
    }
  }

  return result;
}

export default useCampaignFormData;
